import { PlayerService } from './../../player/services/player.service';
import { Pipe, PipeTransform, Component, NgModule } from '@angular/core';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

import { OnInit, Input, Output, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ArtistService, SongsService, ScrollService, ScrollParams } from '../../api/';
import { SearchService, BasicSearchParams } from '../../api';
import * as _ from 'lodash';
import { SongDetailComponent } from '../../songs/song-detail/song-detail.component';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Ng2TweetService } from 'ng2-tweet/lib/index';
import { NavigationExtras, Router } from '@angular/router';
import { Globals } from '../../app.globals';
declare var $: any;

@Component({
  selector: 'app-artist-detail',
  templateUrl: './artist-detail.component.html',
  styleUrls: ['./artist-detail.component.css']
})
export class ArtistDetailComponent implements OnInit, OnDestroy {
  private artist: any;
  private links: any = new Array<any>();
  private youtubeChannelLinks: any = new Array<any>();
  private websiteLink: any;
  private messages: any = new Array<any>();
  private links2: any = new Array<any>();
  private songs: any = new Array<any>();
  private songsIds: any = new Array<any>();
  private songs2: any = new Array<any>();
  private songs4: any = new Array<any>();
  private songs3: any = new Array<any>();
  private TempSongs: any = new Array<any>();
  private readMoreArray: any = new Array<any>();
  private lyricsArray: any = new Array<any>();
  private nameArray: any = new Array<any>();
  private nameArray2: any = new Array<any>();
  private lyricsArray2: any = new Array<any>();
  private followers: any = new Array<any>();
  private scrollParams = new ScrollParams();
  private scrollSubscriber = null;
  private songBio: string = '';
  private readMore: boolean = false;
  private readMore2: boolean = false;
  private notfound: boolean = false;
  private firstSongTitle: string;
  private type: any = 'video';
  dialogRef: MdDialogRef<SongDetailComponent>;
  private song: any;
  private song2: any;
  songLyrics: any;
  songLyrics2: any;
  songLyrics3: any;
  songAlbumTitle: any;
  length: any;
  tempo: any;
  decade: any;
  vocal_type: any;
  viewAsList: boolean = true;
  youtubeLink: boolean = false;
  socialLink: boolean = false;
  viewAsList2: boolean = false;
  viewAsList3: boolean = false;
  instrumental: any;
  artistTracks: boolean = true;
  checkIfFromArtis: boolean = true;
  private searchTerm: string = '';
  private lastTerm: string = '';
  private totalRecords: number = 0; // for search see all count
  private loading: boolean = true;
  private searchPlaceholder = 'Search Music';
  private lyricSlice: number = 400;
  public creditsArray: any = [];
  public writersArray: any = [];
  public apiUrl: string = new Globals().apiEndpoint;
  // to manage the scroll when getting response for songs
  enableScrollForSongs = true;
  // to manage the scroll when getting response for followers
  enableScrollForFollowers = true;
  // to check if there is no more result
  noMoreResult = false;
  noMoreFollowers = false;
  checkIfMobile = false;
  constructor(private route: ActivatedRoute, private cdRef: ChangeDetectorRef, private songsService: SongsService, private searchService: SearchService, private router: Router, private ng2TweetService: Ng2TweetService, private sanitizer: DomSanitizer, public dialog: MdDialog, private artistService: ArtistService, private scrollService: ScrollService, private playerService: PlayerService) {
    this.scrollParams.page = 0;
    if (screen.width <= 668) {
      this.lyricSlice = 400;
    } else if (screen.width <= 1400) {
      this.lyricSlice = 450;
    } else if (screen.width <= 3070) {
      this.lyricSlice = 550;
    } else {
      this.lyricSlice = 700;
    }
    this.noMoreResult = false;
    this.noMoreFollowers = false;
  }

  ngOnInit() {
    if (screen.width <= 640) {
      this.checkIfMobile = true;
    } else {
      var btn = document.getElementById("123");
      btn.click();
    }
    this.scrollService.enableScrollIfDisabled();
    this.links = new Array<any>();
    this.route.params.subscribe((params) => {
      if (params['user_id']) {
        localStorage.setItem('share_id', params['user_id']);
        localStorage.setItem('download_share_id', params['user_id']);
      }
    });
    this.route.params.subscribe((params) => {
      let slug = params['artistSlug'].replace(/.html$/, '')
      this.artistService.getArtistDetailsBySlug(slug)
        .subscribe((res) => {
          this.artist = res;
          if (this.artist) {
            // to manage the social links
            this.manageSocialLinks(res);
            // to get the artist's tracks
            this.getTracks();
          } else {
            this.scrollService.toggleProgressBar(false);
            this.notfound = true;
          }
        });
      // $.get(this.apiUrl+"artists/by-slug/"+params['artistSlug']).done((res) => {
      //   console.log(res);
      // })
    });
    this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getTracks());
    this.songs = _.uniqBy(this.songs, 'id');
    this.cdRef.detectChanges();
    // to check if the url is for share purpose
    this.route.queryParams.subscribe((params) => {
      if (params['share']) {
        // to adjust the volume
        setTimeout(() => {
          this.playerService.adjustVolumeSlider(50);
        }, 2000);
      }
    });
  }

  // to manager social links
  manageSocialLinks(res) {
    this.links = new Array<any>();
    this.youtubeChannelLinks = new Array<any>();
    res.links.forEach((link) => {
      if (link.source == "YouTube") {
        var videoId = this.getId(link.url);
        if (videoId != 'error' && videoId != '' && videoId.length == 11) {
          var tempUrl = "https://www.youtube.com/embed/" + videoId;
          link.url = tempUrl;
          this.links.push(link);
        }
        if (link.url.includes("youtube.com/channel")) {
          res.youtubechannellinks.forEach((link) => {
            var videoId = this.getId(link);
            if (videoId != 'error' && videoId != '' && videoId.length == 11) {
              var tempUrl = "https://www.youtube.com/embed/" + videoId;
              link = tempUrl;
              this.links.push({ "url": link, "source": "YouTube" });
            }
          });
        }
      }
      if (link.source == "Official Website") {
        this.websiteLink = link.url;
        this.links.push(link);
      }
      if (link.source == "Twitter") {
        this.links.push(link);
      }
      if (link.source == "Facebook") {
        var fbId = this.getFbUrl(link.url);
        var timeLineTab = "&tabs=timeline";
        if (fbId != 'error') {
          var tempUrl = "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F" + fbId + timeLineTab;
          link.url = tempUrl;
        }
        this.links.push(link);
      }
    });
    this.arrangLinks();
    this.songs = new Array<any>();
    if (res.bio) {
      this.songBio = res.bio.split(/\s+/).slice(0, 100).join(' ').replace(/[^\x00-\x7F]/g, '');
    }
    this.scrollParams.page = 1;
  }

  load() {
    location.href = this.router.url;
  }

  getId(url) {
    if (url.includes("youtube.com/watch?v")) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);
      if (match && match[2].length == 11) {
        return match[2];
      } else {
        return 'error';
      }
    }
    else {
      return "";
    }
  }

  arrangLinks() {
    this.links2 = new Array<any>();
    var tempFbUrl = "";
    this.youtubeLink = false;
    this.socialLink = false;
    var linksLength = this.links.length;
    if (linksLength > 0) {
      for (var i = 0; i < linksLength; i++) {
        if (this.links[i].source != 'Facebook') {
          if (this.links[i].source == 'YouTube') {
            this.youtubeLink = true;
          }
          if (this.links[i].source == 'Twitter') {
            this.socialLink = true;
          }
          this.links2.push(this.links[i]);
        }
        if (this.links[i].source == 'Facebook') {
          this.socialLink = true;
          tempFbUrl = this.links[i];
        }
      }
      if (tempFbUrl != "") {
        this.links2.push(tempFbUrl);
      }
    }
  }

  getFbUrl(url) {
    var regExp = url.split('.com/');
    var match = regExp[1];
    if (match && match.length > 0) {
      return match;
    } else {
      return 'error';
    }
  }

  mouseHovering(index) {
    this.songs[index].isHovering = true;
  }

  mouseLeaving(index) {
    this.songs[index].isHovering = false;
  }

  openSongDetail(event) {
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    this.dialogRef = this.dialog.open(SongDetailComponent, {
      width: width
    });
    this.dialogRef.componentInstance.slug = this.song.slug;
    return false;
  }

  getUrl(link) {
    let url = this.sanitizer.bypassSecurityTrustResourceUrl(link.url);
    return url;
  }

  getTracks(index = 0) {
    if (index === 0 && this.artist) {
      if (this.enableScrollForSongs == true) {
        this.scrollService.toggleProgressBar(true);
        // set to false until we get the response
        this.enableScrollForSongs = false;
        var that = this;
        $.get(this.apiUrl + "artists/tracks?offset=" + this.scrollParams.page + "&artistId=" + this.artist.id).done((artistSongs) => {
          // to disable the scroll untill we get  the response
          that.scrollService.toggleProgressBar(false);
          artistSongs.forEach((song) => {
            song.playedFrom = 'artist';
            if (song.lyrics != null) {
              song.songLyrics = song.lyrics;
              song.songLyrics2 = song.songLyrics.slice(0, that.lyricSlice);
            }
            that.songs.push(song);
          });
          if (that.songs) {
            that.getFirstSong();
            that.getlyrics();
            that.songs2 = _.sortBy(that.songs, 'updated_at');
            that.songs2 = that.songs2.reverse();
          }
          that.songs = _.uniqBy(that.songs, 'id');
          that.scrollParams.page++;
          // to check if response exists or not
          if (artistSongs.length == 0 || artistSongs.length < 20) {
            that.noMoreResult = true;
            that.enableScrollForSongs = false;
          } else {
            that.enableScrollForSongs = true;
          }
        });
      } else {
        let x = document.getElementById("noRecord");
        if (x) {
          x.setAttribute("style", "display:block;");
        }
      }
    } else if (this.artist) {
      // when tab is changed to followers and index is 1
      if (this.enableScrollForFollowers == true) {
        this.scrollService.toggleProgressBar(true);
        this.enableScrollForFollowers = false;
        this.artistService.loadFollowers(this.scrollParams.page, this.artist.id).subscribe((artistFollowers) => {
          this.scrollService.toggleProgressBar(false);
          this.followers = artistFollowers;
          if (artistFollowers.length == 0 || artistFollowers.length < 20) {
            this.noMoreFollowers = true;
            this.enableScrollForFollowers = false;
          } else {
            this.enableScrollForFollowers = true;
            this.noMoreFollowers = false;
          }
        });
      } else {
        let x = document.getElementById("noRecord");
        if (x) {
          x.setAttribute("style", "display:block;");
        }
      }
    }
    this.TempSongs = this.songs;
  }

  removeFromQue() {
    let x = document.getElementById("noRecord");
    x.setAttribute("style", "display:none;");
  }

  tabChanged(event) {
    if (event.index === 0) {
      // when songs tab is active then disable the artist followers call
      this.enableScrollForSongs = true;
      this.enableScrollForFollowers = false;
    } else if (event.index === 1) {
      // when followers tab is active then disable the artist tracks call
      this.enableScrollForSongs = false;
      this.enableScrollForFollowers = true;
    }
    this.scrollParams = new ScrollParams();
    this.scrollParams.page = 0;
    this.followers = new Array<any>();
    this.getTracks(event.index);
  }

  // for the artist and video tabs
  tabChanged2(event) {

  }

  toggleReadMore() {
    this.readMore = !this.readMore;
  }

  toggleReadMore2() {
    this.readMore2 = !this.readMore2;
  }

  toggleReadMore3(i) {
    this.readMoreArray[i] = !this.readMoreArray[i];
  }

  getFirstSong() {
    for (let i = 0; i < 1; i++) {
      this.song = this.songs[0];
      this.song2 = this.songs[0 + 1];
      if (this.songs[0]) {
        if (this.songs[0].name != null || this.songs[0].name != "") {
          this.firstSongTitle = this.songs[0].name;
        }
        if (this.songs[0].album != null) {
          this.songAlbumTitle = this.songs[0].album.name;
        }
        if (this.songs[0].length != null || this.songs[0].length != "") {
          this.length = this.songs[0].length;
        }
        if (this.songs[0].tempo != null || this.songs[0].tempo != "") {
          this.tempo = this.songs[0].tempo;
        }
        if (this.songs[0].decade != null || this.songs[0].decade != "") {
          this.decade = this.songs[0].decade;
        }
        if (this.songs[0].vocal_type != null || this.songs[0].vocal_type != null) {
          this.vocal_type = this.songs[0].vocal_type;
        }
        if (this.songs[0].instrumental != null || this.songs[0].instrumental != "") {
          this.instrumental = this.songs[0].instrumental;
        }
        if (this.songs[0].lyrics != null) {
          this.songLyrics = this.songs[0].lyrics;
          this.songLyrics2 = this.songLyrics.slice(0, (this.songLyrics.length / 3) * 2);
        }
      }
    }
  }

  getlyrics() {
    for (let i = 0; i < this.songs.length; i++) {
      if (this.songs[i].lyrics != null) {
        this.lyricsArray2[i] = this.songs[i].lyrics.split(/\s+/).slice(0, this.songs[i].lyrics.length).join(' ').replace(/[^\x00-\x7F]/g, '');
        this.lyricsArray[i] = this.songs[i].lyrics.split(/\s+/).slice(0, 31).join(' ').replace(/[^\x00-\x7F]/g, '');
        this.readMoreArray[i] = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.scrollSubscriber != null) {
      this.scrollSubscriber.unsubscribe();
    }
  }

  toggleViewAsList(value) {
    this.viewAsList = true;
    if (value) {
      this.viewAsList2 = false;
      this.viewAsList3 = false;
      if (document.getElementById('Ui123456') != null) {
        document.getElementById('Ui123456').className = 'app-content';
      }
      if (document.getElementById('Ui12345') != null) {
        document.getElementById('Ui12345').className = 'app-content';
      }
    }
    if (this.viewAsList3 != false) {

    }
  }

  toggleViewAsList2(value) {
    this.viewAsList2 = true;
    if (value) {
      this.viewAsList = false;
      this.viewAsList3 = false;
      if (document.getElementById('Ui123456') != null) {
        document.getElementById('Ui123456').className = 'app-content';
      }
      if (document.getElementById('Ui12345') != null) {
        document.getElementById('Ui12345').className = 'app-content';
      }
    }
    if (this.viewAsList3 == true) {

    }
    if (this.viewAsList3 != false) {
      if (document.getElementById('Ui123456') != null) {
        document.getElementById('Ui123456').className = 'app-content';
      }
      if (document.getElementById('Ui12345') != null) {
        document.getElementById('Ui12345').className = 'app-content';
      }
    }
  }

  toggleViewAsList3(value) {
    this.viewAsList3 = true;
    if (value) {
      this.viewAsList = false;
      this.viewAsList2 = false;
      if (document.getElementById('Ui123456') != null) {
        document.getElementById('Ui123456').className = 'app-content2';
      }
      if (document.getElementById('Ui12345') != null) {
        document.getElementById('Ui12345').className = 'app-content2';
      }
    }
  }

  handleSearch(event) {
    this.searchTerm = event.searchTerm;
    this.songs3 = new Array<any>();
    if (event.searchTerm = !"") {
      this.songs = this.TempSongs;
      for (let i = 0; i < this.songs.length; i++) {
        var namee = this.songs[i].name.toUpperCase();
        if (namee.indexOf(this.searchTerm.toUpperCase()) >= 0) {
          this.songs3.push(this.songs[i]);
        }
      }
      this.songs = this.songs3;
    } else {
      this.songs = new Array<any>();
      this.songs = this.TempSongs;
    }
  }

  refreshList() {
    this.getTracks();
  }

}



// WEBPACK FOOTER //
// ./src/app/artists/artist-detail/artist-detail.component.ts